import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function removeTopicFromClauses(requestor) {
  return createReduxPromiseAction(
    ActionTypes.CLAUSES_TOPIC_REMOVE,
    (organisationId, topicId, data) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}/topic/${topicId}/remove-clauses`,
          data,
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
